import React from 'react'
import UpdatedSoon from '../Component/UpdatedSoon'

export default function Programme() {
  return (
    <>
          <UpdatedSoon />
    </>
  )
}
